import { Collapse } from "@blueprintjs/core";
import * as React from "react";
import { INotification } from "~/containers/Notifications/NotificationsContainer";
import { StyledCallout as Callout } from "~/layouts/StyledCallout";
import styled from "~/styled";

interface IProps {
  notification: INotification;
}

const StyledCallout = styled(Callout)`
  cursor: pointer;

  &:active {
    -webkit-tap-highlight-color: transparent;
  }
`;

export default class Notification extends React.Component<IProps> {
  public state = {
    isOpen: true
  };

  public render() {
    const {
      notification: { title, description, intent }
    } = this.props;

    return (
      <StyledCallout title={title} intent={intent} onClick={this.handleClick}>
        <Collapse isOpen={this.state.isOpen}>
          <div dangerouslySetInnerHTML={{ __html: description }} />
        </Collapse>
      </StyledCallout>
    );
  }

  private handleClick = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };
}



// WEBPACK FOOTER //
// ./src/components/Notifications/Notification.tsx